import React from 'react';

import {
  WorkerAssignedContainer,
  WorkerAssignedHeader,
  WorkerAssignedTitle,
  WorkerDetailsBox,
  WorkerAvatar,
  WorkerInfoText,
  WorkerName,
  WorkerMetaText,
} from './styles';

interface WorkerAssignedProps {
  workerName: string;
  workerId: number;
  workerRole: string;
  avatarSrc?: string;
}

const WorkerAssigned: React.FC<WorkerAssignedProps> = ({
  workerName,
  workerId,
  workerRole,
  avatarSrc,
}) => {
  

  return (
    <WorkerAssignedContainer>
      <WorkerAssignedHeader>
        <WorkerAssignedTitle variant="subtitle1">
          Worker Assigned
        </WorkerAssignedTitle>
      </WorkerAssignedHeader>

      <WorkerDetailsBox>
        <WorkerAvatar src={avatarSrc} alt={workerName} />
        <WorkerInfoText>
          <WorkerName variant="body1">{workerName}</WorkerName>
          <WorkerMetaText variant="body2">ID: {workerId}</WorkerMetaText>
          <WorkerMetaText variant="body2">Role: {workerRole}</WorkerMetaText>
        </WorkerInfoText>
      </WorkerDetailsBox>
    </WorkerAssignedContainer>
  );
};

export default WorkerAssigned;